import '../styles/elements/header.scss';
import Logo from '../assets/logo.png'
import WFLogo from '../assets/wf-logo.png'

export default function Header() {
    return (
        <header>
            <div className={'logo_and_name'}>
                <h3>Настройки приложения "Отчеты по звонкам"</h3>
            </div>
            <div className={'right-elements'}>

                {/*<button className={'settings'}>*/}
                {/*    <SettingsLogo/>*/}
                {/*</button>*/}
                <div className={'wf-logo'}>
                    <a href='https://www.webformat.ru' target={'_blank'}>
                        <img className={'webformat-logo'} src={WFLogo}></img>
                    </a>
                </div>
            </div>
        </header>
    )
}